import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toggleCartCommission} from "../../actions/Properties";
import {getCartCommissionValue} from "../../selectors/SimpleSelectors";
import Checkbox from "../../components/Checkbox";

function mapStateToProps(state) {
    return {
        activeCommission: getCartCommissionValue(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        toggleCartCommission: () => {
            return dispatch(toggleCartCommission())
        }
    };
}

class AffiliateToggleForm extends Component {
    render() {
        return (
            <div className="configuration-step__custom-group configuration-step__custom-group--commission">
                <h2>Betreuungsfreigabe für Agentur</h2>
                <p className="clientdata-step__commission__info">Aktiviere die Freigabe, wenn du beim Hosting deines Projekts von einer Agentur betreut wirst. Damit bestätigst du, dass die Agentur auf deine Hosting-Pakete und Vertragsdaten zugreifen darf. Auch kostenpflichtige Bestellungen (bspw.
                    von Domains) darf die Agentur in deinem Namen tätigen.</p>
                <Checkbox input={{
                    checked: !!this.props.activeCommission, onChange: (isChecked) => {
                        this.props.toggleCartCommission();
                    }
                }} meta={{}} label={"Betreuungsfreigabe aktivieren"}/>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AffiliateToggleForm);


/** WEBPACK FOOTER **
 ** ./src/containers/clientdata/AffiliateToggleForm.js
 **/